export default function IsImageFactory($q) {
  function checkSrc(src) {
    const deferred = $q.defer();

    const image = new Image();

    image.onerror = () => deferred.reject();

    image.onload = () => deferred.resolve();

    image.src = src;

    return deferred.promise;
  }
  return {
    checkSrc
  };
}

IsImageFactory.$inject = ['$q'];
